import { isNotNil } from 'global/utils';
import { collectImageComponentParams } from 'strapi/component/shared/collector';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { collectButtonComponentParams } from '../landingButton';
import { ReactComponentType } from '../types';

import { HeroSection } from './HeroSection';
import { HeroSectionProps, HeroSectionStrapiComponent } from './types';

export const collectHeroSectionComponentParams = (
  data: HeroSectionStrapiComponent,
  page: PageTypes
): HeroSectionProps | undefined => {
  const buttons = data.buttons
    ?.map((x) => collectButtonComponentParams(page, x))
    .filter(isNotNil);

  const image = collectImageComponentParams(data.image);

  if (!image) {
    return undefined;
  }

  return {
    title: data.title,
    description: data.description,
    backgroundGradient: data.backgroundGradient,
    image: image,
    button: buttons && buttons.length > 0 ? buttons[0] : undefined,
    imageSize: data.imageSize,
    showCompanies: !!data.brands,
  };
};

export const collectHeroSectionParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof HeroSection> | undefined => {
  if (!('heroSection' in page) || !page.heroSection) {
    return undefined;
  }

  const props = collectHeroSectionComponentParams(page.heroSection, page);

  if (!props) {
    return undefined;
  }

  return {
    component: ReactComponentType.HeroSection,
    props: props,
  };
};
